module.exports = __webpack_public_path__ + "static/367117_2_0-e087a7f01624f825f7c8560e593aa828.ttf";